<template>
      <el-popover class="sportFootballMatchStatusSettings"
        placement="bottom"
        width="210"
        trigger="click"
        popper-class="SportFootballMatchStatusSettings">
        <status-settings-items :match="match"/>
        <el-button slot="reference" plain type="primary" size="mini" icon="el-icon-setting" />
      </el-popover>
</template>

<script>
import StatusSettingsItems from './StatusSettingsItems'

export default {
  name: 'SportFootballMatchStatusSettings',
  components: { StatusSettingsItems },
  props: {
    match: Object
  }
}
</script>

<style>
.sportFootballMatchStatusSettings{
  position:absolute;
  display:flex;
  justify-content: space-around;
  top:29px;
  left:0;
  width:9%;
  height:60px;
}
.sportFootballMatchStatusSettings > button{
  flex: 0 1 35px;
  align-self: center;
  justify-self:center;
  height:25px;
  border:none;
  box-sizing:border-box;
  padding:0;
  line-height:25px;
  font-size:18px;
}
</style>
